<template>
  <div>
    <my-dialog
      :title="'修改密码'"
      data-warden-title="修改密码"
      :confirmButtonText="'保存'"
      ref="changePassword"
      class="changePassword"
    >
      <change-password ref="passForm"></change-password>
    </my-dialog>
  </div>
</template>

<script>
import ChangePassword from "@/components/ChangePassword.vue";
import MyDialog from "@/components/MyDialog.vue";
import CryptoJS from "crypto-js";
import { Message } from "element-ui";
export default {
  name: "ChangePasswordPage",
  components: {
    MyDialog,
    ChangePassword
  },
  data() {
    return {
      userId: null
    };
  },
  mounted() {
    this.changePassword();
  },
  methods: {
    changePassword() {
      //   this.username = this.$route.query.username;
      if (this.$route.query.userId != null) {
        this.userId = this.$route.query.userId;
      }
      //   alert(this.userId);
      this.$refs.changePassword.open(
        () => {
          if (this.$refs.passForm.flag) {
            let url = "retrieve/user/changePasswordByUserId";
            let oldPassword = this.$refs.passForm.form.oldPassword.text;
            let newPassword = this.$refs.passForm.form.newPassword.text;
            oldPassword = CryptoJS.MD5(oldPassword).toString();
            newPassword = CryptoJS.MD5(newPassword).toString();
            let params = new URLSearchParams();
            params.append("userId", this.userId);
            params.append("oldPassword", oldPassword);
            params.append("newPassword", newPassword);
            this.$http
              .post(url, params)
              .then(res => {
                Message({
                  type: "success",
                  message: "密码修改成功!"
                });
                localStorage.removeItem("username");
                this.$router.replace("/home");
              })
              .catch(err => {
                this.changePassword();
              });
          } else {
            Message({
              type: "error",
              message: "请检查输入!"
            });
            this.changePassword();
          }
        },
        () => {
          localStorage.removeItem("username");
          this.$router.replace("/home");
        }
      );
    }
  }
};
</script>

<style scoped>
.changePassword >>> .el-dialog {
  width: 350px;
  margin-top: 30vh !important;
}
</style>



// WEBPACK FOOTER //
// src/views/home/ChangePasswordPage.vue